module.exports = __webpack_public_path__ + "img/qr-wx.8b17c71b.png";